import { createSlice } from 'redux-starter-kit'

function exportLayerRequest(state, action) {
  return ({ ...state, fetching: true, error: false, success: false })
}

function exportLayerSuccess(state, action) {
  return { ...state, fetching: false, error: false, success: true }
}

function exportLayerFailure(state, action) {
  console.warn({ action })
  return ({ ...state, fetching: false, error: true, success: false })
}

const exportLayer = createSlice({
  slice: 'exportLayer',
  initialState: {
    fetching: false,
    error: false,
    success: false,
    item: {}
  },
  reducers: {
    exportLayerRequest,
    exportLayerSuccess,
    exportLayerFailure
  }
})

export default exportLayer



// WEBPACK FOOTER //
// ./src/redux/exportLayerDuck.js